import { useSetAtom } from "jotai";
import { useModals } from "src/components/Modals";
import { importPlanogramsFromPsaModalDataAtom, ImportPlanogramsFromPsaModalData } from "./atoms";

interface UseImportPlanogramsFromPsaModalResult {
  openImportPlanogramsFromPsaModal: (data: ImportPlanogramsFromPsaModalData) => void;
}

export const useImportPlanogramsFromPsaModal = (): UseImportPlanogramsFromPsaModalResult => {
  const { openModal } = useModals();
  const setImportPlanogramsFromPsaModalData = useSetAtom(importPlanogramsFromPsaModalDataAtom);

  const openImportPlanogramsFromPsaModal = (data: ImportPlanogramsFromPsaModalData) => {
    setImportPlanogramsFromPsaModalData(data);
    openModal("ModalImportPlanogramsFromPsa");
  };

  return { openImportPlanogramsFromPsaModal };
};
